import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

export const PRODUCT_IMAGE_FALLBACK_URL = '/images/VPA.png';

export function getProductImageUrls(imageUrl) {
  if (Array.isArray(imageUrl)) {
    return imageUrl;
  }

  if (imageUrl && typeof imageUrl === 'object') {
    return Object.values(imageUrl);
  }

  if (typeof imageUrl === 'string') {
    try {
      return getProductImageUrls(JSON.parse(imageUrl));
    } catch {
      return [imageUrl];
    }
  }

  return [];
}

function replaceWithFallback(event) {
  if (event.currentTarget.dataset.fallbackApplied) {
    return;
  }

  event.currentTarget.dataset.fallbackApplied = 'true';
  event.currentTarget.src = PRODUCT_IMAGE_FALLBACK_URL;
}

export function ProductImage({ imageUrl, alt, ...imageProps }) {
  const imageUrlValue = getProductImageUrls(imageUrl)
    .find((url) => typeof url === 'string' && url.trim());

  return (
    <img
      {...imageProps}
      src={imageUrlValue || PRODUCT_IMAGE_FALLBACK_URL}
      alt={alt}
      onError={replaceWithFallback}
    />
  );
}

function ProductImageGallery({ imageUrl, productName, ...galleryProps }) {
  const { showNav, ...imageGalleryProps } = galleryProps;
  const imageUrls = getProductImageUrls(imageUrl)
    .filter((url) => typeof url === 'string' && url.trim());
  const items = (imageUrls.length ? imageUrls : [PRODUCT_IMAGE_FALLBACK_URL]).map((url) => ({
    original: url,
    originalAlt: `Imagen de ${productName}`,
    thumbnail: url,
    thumbnailAlt: `Miniatura de ${productName}`
  }));

  const renderItem = (item) => (
    <img
      className="image-gallery-image"
      src={item.original}
      alt={item.originalAlt}
      onError={replaceWithFallback}
    />
  );

  const renderThumbInner = (item) => (
    <img
      className="image-gallery-thumbnail-image"
      src={item.thumbnail}
      alt={item.thumbnailAlt}
      onError={replaceWithFallback}
    />
  );

  return (
    <ImageGallery
      {...imageGalleryProps}
      items={items}
      renderItem={renderItem}
      renderThumbInner={renderThumbInner}
      showNav={typeof showNav === 'boolean' ? showNav : items.length > 1}
    />
  );
}

export default ProductImageGallery;
